import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PermissionsComponent } from './permissions.component';
import { AppMaterialModule } from 'src/app/app-material.module';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { PermissionModule } from './permission/permission.module';
import { RoleModule } from './role/role.module';

@NgModule({
  declarations: [
    PermissionsComponent,
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    AppMaterialModule,
    PermissionModule,
    RoleModule
  ],
  exports: [
    PermissionsComponent
  ]
})
export class PermissionsModule { }
